import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledNotifyAdminModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;

export const StyledNotifyAdminImage = styled.img`
  width: 136px;
  height: 136px;
`;

export const StyledNotifyAdminTitle = styled.div`
  margin-top: 24px;
  ${setFontVariant('h5', colorsPalettes.carbon[400])};
  font-weight: 700;
`;

export const StyledNotifyAdminSubTitle = styled.div`
  margin-top: 12px;
  ${setFontVariant('subTitle3Alt', colorsPalettes.carbon[300])};
  line-height: 24px;
`;
